import { useEffect } from "react"
import { useLocation, useMatch, useParams, useSearchParams } from "react-router-dom"
import Form from "../../components/Form/Form"
import Program from "../../components/Program"
import { useFormContext } from "../../contexts/formContext"

export default function EventPage() {
    let { id } = useParams()
    let [search] = useSearchParams()
    const form = useFormContext()

    useEffect(() => {
        if (form.current && search.get('reg'))
            form.current.scrollIntoView()
        else
            window.scrollTo(0, 0)
    }, [search, form])

    return (
        <>
            <Program eventId={id} />
            <Form eventId={id} />
        </>
    )
}